import ODAS from '@/utils/api/odas';
import moment from 'moment';

/**
 *  Existing angular implementation of these methods can be found in javascripts/services/agency_client.js
 *  */
const AgencyClient = {
  loadAgencyClient: ({ id, params }) => {
    return ODAS.get('api/agency_clients/' + id, { options: JSON.stringify(params) });
  },
  updateCBOAgencyClientAccessEvent: (options, params) => {
    params = params || {};
    params.access_event = options;

    return ODAS.put('/api/organizations/agency_clients/' + options.agencyClientId + '/access_events/' + options.accessEventId, params);
  },
  updateAgencyClientAccessEvent: (options, agencyClientId, accessEventId) => {
    return ODAS.put(`/api/agency_clients/${agencyClientId}/access_events/${accessEventId}`, options);
  },
  updateAgencyClient: (agencyClientHash, agencyClientId) => {
    return ODAS.put('/api/agency_clients/' + agencyClientId, agencyClientHash);
  },
  deleteAgencyClient: (agencyClientId) => {
    return ODAS.delete('/api/agency_clients/' + agencyClientId);
  },
  removeAgencyClientFromList: (agencyClientId) => {
    return ODAS.post('api/agency_clients/' + agencyClientId + '/remove');
  },
  addAgencyClient: (agencyClientId) => {
    return ODAS.post('api/agency_clients/' + agencyClientId + '/add');
  },
  loadAgencyClientFromAgencyDB: (externalClientId) => {
    return ODAS.get('api/agency_clients/import', { params: { external_client_id: externalClientId } });
  },
  loadCurrentUserAgencyClient: (params) => {
    return ODAS.get('api/agency_clients?', params);
  },
  loadUserAgencyClientsWithMultipleFields: (pagination, query, scope, sort_by, sort_order, options) => {
    const params = {};
    params.options = {};
    params.page = pagination.page;
    params.per_page = pagination.per_page;
    params.sort_by = sort_by;
    params.sort_order = sort_order;
    params.scope = scope;
    params.options = options;

    Object.assign(params, query);

    return ODAS.get('/api/agency_clients/by_match_fields', params);
  },
  createAgencyClient: (agencyClientHash) => {
    return ODAS.post('/api/agency_clients', { agency_client: agencyClientHash });
  },
  loadAgencyClientReferralsList: (options, params) => {
    return ODAS.get(`/api/agency_clients?options=${JSON.stringify(options)}`, params);
  },
  loadCboAgencyClients: () => {
    return ODAS.get('/api/organizations/agency_clients');
  },
  loadCboAgencyClient: (agencyClientId) => {
    return ODAS.get('/api/organizations/agency_clients/' + agencyClientId);
  },
  loadAffiliations: function (organizationId, options) {
    options = options || {};

    return ODAS.get('/api/organizations/' + organizationId + '/affiliations', { params: options });
  },
  loadAgencyClientByExternalClientId: (externalClientId, agencyFetchableId) => {
    return ODAS.get('/api/agency_clients/exists', { external_client_id: externalClientId, agency_id: agencyFetchableId });
  },
  inviteSupporters: (supporterEmails) => {
    return ODAS.post('api/agency_clients/supporters', { supporter_emails: supporterEmails });
  },

  updateSupporterPermission: ({ agency_client_id, supporter_id, permission_type }) => {
    return ODAS.put(`/api/agency_clients/${agency_client_id}/permissions/${supporter_id}`, {
      permission: { agency_client_id, supporter_id, permission_type }
    });
  },
  loadUserAgencyClients: (pagination, query, scope, sort_by, sort_order, options) => {
    const params = {};
    params.page = pagination.page;
    params.per_page = pagination.per_page;
    params.sort_by = sort_by;
    params.sort_order = sort_order;
    params.scope = scope;
    params.q = query.q;

    if (query.createdDates && query.createdDates.startDate) {
      params.created_after = moment(query.createdDates.startDate).format('YYYY-MM-DD');
    }
    if (query.createdDates && query.createdDates.endDate) {
      params.created_before = moment(query.createdDates.endDate).format('YYYY-MM-DD');
    }
    if (query.createdDates && query.updatedDates.startDate) {
      params.updated_after = moment(query.updatedDates.startDate).format('YYYY-MM-DD');
    }
    if (query.createdDates && query.updatedDates.endDate) {
      params.updated_before = moment(query.updatedDates.endDate).format('YYYY-MM-DD');
    }

    return ODAS.get(`/api/agency_clients?options=${JSON.stringify(options)}`, params);
  }
};

export default AgencyClient;
